import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/store/Navbar";
import { Footer } from "@/components/store/Footer";
import { CartDrawer } from "@/components/store/CartDrawer";
import { BottomNav } from "@/components/store/BottomNav";
import { ProductModalProvider } from "@/context/ProductModalContext";
import { Onboarding } from "@/components/store/Onboarding";
import { WhatsAppFloat } from "@/components/store/WhatsAppFloat";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

export default function StoreLayout() {
  return (
    <ProductModalProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-cream">
        <Navbar />
        <main className="flex-1 pb-24 md:pb-0">
          <Outlet />
        </main>
        <Footer />
      </div>
      <CartDrawer />
      <BottomNav />
      <WhatsAppFloat />
      <Onboarding />
    </ProductModalProvider>
  );
}
